export const removeNonNumberChar = (text: string) => {
  return text.replace(/[^0-9]*/g, '');
};

export const isNumeric = (value: string) => {
  return /^-?\d+$/.test(value);
};
